<template>
  <div style="background: rgba(0,0,0,0);" class="expande-horizontal wrap pa-3">
    <v-flex xs12 md3 class="pr-2">
      <v-text-field
        dense
        solo
        background-color="#e2e2e2"
        small
        flat
        label="Filtrar por nome"
        v-model="get_relatorios_filtros.nome"
        clearable
        hide-details
        :color="$theme.primary"
        @input="debounceSearch"
      ></v-text-field>
    </v-flex>

    <!-- <v-flex xs12 md3 class="pr-2 pb-1">
      <v-autocomplete
        dense
        solo-inverted
        small
        flat
        item-text="nome"
        return-object
        label="Filtrar por Categoria"
        :items="get_relatoriocategorias.docs"
        v-model="get_relatorios_filtros.categoria"
        item-value="id"
        clearable
        hide-details
        @input="debounceSearch"
      ></v-autocomplete>
    </v-flex> -->

    <!-- <v-flex xs12 md2 class="pr-2 pb-1">
            <v-select
                dense
                solo-inverted
                flat
                label="Filtrar por status"
                clearable
                v-model="get_relatorios_filtros.status_atual"
                @input="debounceSearch"
                hide-details
                :items="['EM ABERTO']"
            ></v-select>
        </v-flex> -->
    <v-flex xs12 md3 class="pr-2">
      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense
            solo
            background-color="#e2e2e2"
            flat
            hide-details
            readonly
            clearable
            label="Data inicial"
            prepend-inner-icon="mdi-calendar"
            v-model="computedInitialDate"
            v-bind="attrs"
            v-on="on"
            @click:clear="clearDate('dataInicio')"
          ></v-text-field>
        </template>
        <v-date-picker
          lang="pt-br"
          type="date"
          v-model="get_relatorios_filtros.dataInicio"
          @input="menu1 = false; listar_relatorios()"
        ></v-date-picker>
      </v-menu>
    </v-flex>

    <v-flex xs12 md3 class="pr-2">
      <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense
            solo
            background-color="#e2e2e2"
            flat
            hide-details
            readonly
            clearable
            label="Data final"
            prepend-inner-icon="mdi-calendar"
            v-model="computedFinalDate"
            v-bind="attrs"
            v-on="on"
            @click:clear="clearDate('dataFim')"
          ></v-text-field>
        </template>
        <v-date-picker
          lang="pt-br"
          type="date"
          v-model="get_relatorios_filtros.dataFim"
          @input="menu2 = false; listar_relatorios()"
        ></v-date-picker>
      </v-menu>
    </v-flex>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      menu: false,
      menu1: false,
      menu2: false,
      dates1: "",
      dates2: ""
    };
  },
  computed: {
    ...mapGetters([
      "get_funcionarios",
      "get_clientes",
      "get_relatoriocategorias",
      "get_relatorios_filtros"
    ]),
    computedInitialDate: {
      get() {
        if (!this.get_relatorios_filtros.dataInicio) {
          return "";
        }
        const data = this.$moment(
          this.get_relatorios_filtros.dataInicio
        ).format("DD/MM/YYYY");
        return data === "Invalid date" || data === "Data inválida" ? "" : data;
      },
      set(value) {
        this.get_relatorios_filtros.dataInicio = value;
      }
    },
    computedFinalDate: {
      get() {
        if (!this.get_relatorios_filtros.dataFim) {
          return "";
        }
        const data = this.$moment(this.get_relatorios_filtros.dataFim).format(
          "DD/MM/YYYY"
        );
        return data === "Invalid date" || data === "Data inválida" ? "" : data;
      },
      set(value) {
        this.get_relatorios_filtros.dataFim = value;
      }
    }
  },
  methods: {
    ...mapActions(["listar_relatorios"]),
    clearDate(field) {
      this.get_relatorios_filtros[field] = "";
      this.listar_relatorios();
    },
    debounceSearch() {
      const x = _.debounce(this.listar_relatorios, 800);
      x();
    }
  }
};
</script>
